import * as React from 'react';
import TextField from '@mui/material/TextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DateTimePicker from '@mui/lab/DateTimePicker';

export default function BasicDateTimePicker(props) {
  const sortedValues = [...props.values].sort((a, b) => new Date(b) - new Date(a));
  const [valueFrom, setValueFrom] = React.useState(sortedValues.at(-1));
  const [valueTo, setValueTo] = React.useState(sortedValues[0]);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} size="small">
      <DateTimePicker
        renderInput={(props) => <TextField {...props} />}
        label="From"
        size="small"
        value={valueFrom}
        maxDateTime={new Date(valueTo)}
        minDateTime={new Date(sortedValues.at(-1))}
        onChange={(newValueFrom) => {
          setValueFrom(new Date(new Date(newValueFrom).getTime() - 3600));
          props.filter([newValueFrom, valueTo]);
        }}
      />
      <div style={{marginBottom: '10px'}}></div>
      <DateTimePicker
        renderInput={(props) => <TextField {...props} />}
        label="To"
        size="small"
        value={valueTo}
        maxDateTime={new Date(sortedValues[0])}
        minDateTime={new Date(valueFrom)}
        onChange={(newValueTo) => {
          setValueTo(newValueTo);
          props.filter([valueFrom, newValueTo]);
        }}
      />
    </LocalizationProvider>
  );
}